import React from 'react'
import Navigationtitle from "../include/Navigationtitle";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { useState, useEffect, useCallback, useContext } from "react";

export default function Importplayers(match) {
    const [selectedFile, setSelectedFile] = useState(null);
    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    function sampledownload() {
        const fileName = "Sample.xlsx"; // Replace with your actual file name
        const fileUrl = `${process.env.PUBLIC_URL}/${fileName}`;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        link.click();
    }

    return (
        <>          <Navigationtitle data={match} />
            <div className="importbg">
                <div className="importmain">
                    <div className="importmsg">
                        <p>You can add bulk of Players by just importing the excel</p>
                    </div>
                    <div className="impflex">
                        <div className="importsample">
                            <div><p>Excel must be in a predefined format !!<br />Confused ? This sample excel helps you to know the format</p></div>
                            {/* <div><p>This sample excel helps you to know the format</p></div> */}
                            <div><button onClick={() => sampledownload()} style={{ float: 'right' }}><FontAwesomeIcon icon={faDownload} /> &nbsp;Sample excel</button></div>
                        </div>
                        <div className="importdiv">
                            <div className='importtag' onClick={() => document.getElementById('selinpfile').click()} >
                                <label htmlFor="">{selectedFile ? selectedFile.name : 'Choose excel file'}</label>

                                <input type="file" style={{ display: 'none' }} onChange={handleFileChange} class="form-control" id="selinpfile" placeholder="ADD File" />
                            </div>

                            <div>
                                <label style={{ color: 'gray' }} htmlFor="">Type of update you want to do</label>
                                <select id="inputState" class="form-control">
                                    <option value="" selected>Insert</option>
                                    <option value="pi">Partial Insert</option>
                                    <option value="1">Update</option>
                                    <option value="2">Update Category</option>
                                    <option value="3">Update specification</option>
                                    <option value="sp1">Update specification 1</option>
                                    <option value="sp2">Update specification 2</option>
                                    <option value="sp3">Update specification 3</option>
                                    <option value="sp1same">Text specification 1</option>
                                    <option value="sp2same">Text specification 2</option>
                                    <option value="name">Update Name</option>
                                    <option value="mob">Update Mobile</option>
                                    <option value="icon">Update Icon</option>
                                    <option value="run">Update states (R,s...)</option>
                                    <option value="photo">Update photo</option>
                                    <option value="detail">Detail</option>
                                    <option value="base">Base Value (Q)</option>
                                    <option value="age">Age(L)</option>
                                    <option value="dobtoage">DOB To Age (E)</option>
                                    <option value="updplno">Update Player Number</option>
                                </select>
                            </div >
                            <div style={{ textAlign: 'center' }}>

                                <button type="submit" class="mysubbtn my-5">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
